<template lang="html">
    <div class="wrapper">


         <div class="amount_wrapper" v-if="status === states.DETAILS">
<!--                    <h1>{{product.name}}</h1>-->
<!--                    <p>-->
<!--                      {{product.description}}-->
<!--                    </p>-->
                    <label class="amount_label">Quantity </label>
                    <select class="amount_select"
                      type="number"
                      v-model="quantity"
                      title="Add to room bill">
                        <option value="1">1</option>
                        <option value="2">2</option>
                    </select>
                </div>
                <Button
                  :title="`Buy for ${totalAmount}`"
                  :loading="buttonLoading"
                  v-on:click.native="addToRoomBill"

                />


    </div>
</template>

<script>
import Button from '@/components/partials/Button'
import UpsellService from '@/services/UpsellService'
import Modal from '@/components/modals/Modal'
import BaseError from '@/objects/Exceptions/BaseError'
import HttpUnAuthenticatedError from '@/objects/Exceptions/HttpUnAuthenticatedError'
import { toEuro } from '@/filters/money'
const states = {
  IDLE: 'IDLE',
  FETCHING: 'FETCHING',
  DETAILS: 'DETAILS',
  POSTING: 'POSTING',
  ERROR: 'ERROR',
}

export default {
  components: {
    Button,
    Modal
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    mews_upsell: {
      type: [Object, Boolean],
      default: false
    }
  },
  data () {
    return {
      states,
      status: states.IDLE,
      product: {},
      quantity: 1,
      buttonLoading: false
    }
  },
  computed: {
    totalAmount () {
      return toEuro(this.product.price * this.quantity)
    }
  },
  methods: {
    async buy () {
      this.status = states.FETCHING
      this.buttonLoading = true
      try {
        const response = await UpsellService.getUpsellProduct({serviceId: this.mews_upsell.serviceId, externalId: this.mews_upsell.id})
        this.product = response.product
        this.status = states.DETAILS
        this.buttonLoading = false
      } catch (e) {
        this.product = undefined
        this.status = states.ERROR
        this.buttonLoading = false
      }

    },
  addToRoomBill () {
      if (!confirm (`Are you sure you want to order? ${this.totalAmount} will be added to your room bill`)) {
        return false
      }
    const payload = {
      serviceId: this.mews_upsell.serviceId,
      externalId: this.mews_upsell.id,
      quantity: this.quantity
    }
      this.buttonLoading = true
    UpsellService.orderUpsellProduct(payload)
      .then((response) => {
        if (response.ChargeId != null) {
          this.$notify({
              group: 'app',
              type: 'success',
              title: 'Thank you',
              text: 'Your order is recieved',
              closeOnClick: true,
              duration: -1
            })
        } else {
            this.$notify({
              group: 'app',
              type: 'error',
              title: 'Something went wrong',
              text: 'We where unable to process your request. Please reach out to us by chat',
              closeOnClick: true,
              duration: -1
            })
        }

      }).catch((error) => {
        this.$notify({
              group: 'app',
              type: 'error',
              title: 'Something went wrong',
              text: 'We where unable to process your request. Please reach out to us by chat',
              closeOnClick: true,
              duration: -1
            })
    }).finally(() => {
      this.buttonLoading = false
    })
  }
  },
  mounted () {
    this.buy()
  }
}
</script>

<style lang="scss" scoped>
.amount_select {
    padding: 4px;
    width: 60px;
}
.wrapper {
    padding: $padding;
}

    .amount_wrapper {
    margin: 10px;
}
    .amount_label {
        margin-right: 12px;
    }
</style>
